(function () {
  var config = document.querySelector('[data-complementary-auto-add]');
  if (!config) return;

  var giftVariantId = parseInt(config.dataset.variantId, 10);
  var threshold = parseInt(config.dataset.threshold || '1', 10);
  var addQty = parseInt(config.dataset.quantity || '1', 10);

  if (!giftVariantId) return;

  var cartTitle = config.dataset.cartTitle || '';
  var cartMessage = config.dataset.cartMessage || '';
  var noLink = config.dataset.noLink === 'true';

  var GIFT_PROPERTY = '__is_free_gift';
  var DISMISSED_KEY = '_giftDismissed_' + giftVariantId;
  var isProcessing = false;

  // Suit l'édition de quantité par l'utilisateur dans le tiroir.
  if (!window.__cosCartEditTracker) {
    window.__cosCartEditTracker = true;
    window.__cosCartEditingUntil = 0;
    var markEditing = function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('cart-drawer .quantity__button, cart-drawer .quantity__input')) {
        window.__cosCartEditingUntil = Date.now() + 1500;
      }
    };
    document.addEventListener('click', markEditing, true);
    document.addEventListener('input', markEditing, true);
  }

  // Réconciliation cadeau DÉBOUNCÉE : on n'ajoute/retire le cadeau (et on ne
  // rafraîchit le tiroir) qu'une fois l'utilisateur au repos. Pendant l'édition,
  // aucune insertion de ligne cadeau → index de ligne stables, pas de bounce.
  var giftReconcileTimer = null;
  function scheduleGiftReconcile(originalFetch) {
    if (giftReconcileTimer) clearTimeout(giftReconcileTimer);
    giftReconcileTimer = setTimeout(function () {
      giftReconcileTimer = null;
      if (Date.now() < (window.__cosCartEditingUntil || 0)) { scheduleGiftReconcile(originalFetch); return; }
      originalFetch(routes.cart_url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) enforceGiftFromCart(cart, originalFetch, false); })
        .catch(function () {});
    }, 900);
  }

  function giftProperties() {
    var props = { __is_free_gift: 'true' };
    if (cartTitle) props.__cart_title = cartTitle;
    if (cartMessage) props.__cart_message = cartMessage;
    if (noLink) props.__no_link = 'true';
    return props;
  }

  function isGiftDismissed() {
    try { return sessionStorage.getItem(DISMISSED_KEY) === 'true'; } catch (e) { return false; }
  }

  function setGiftDismissed() {
    try { sessionStorage.setItem(DISMISSED_KEY, 'true'); } catch (e) {}
  }

  function clearGiftDismissed() {
    try { sessionStorage.removeItem(DISMISSED_KEY); } catch (e) {}
  }

  // Refresh cart drawer + icon bubble in parallel
  function refreshCartDrawer(originalFetch) {
    // Anti « bounce-back » : si l'utilisateur édite une quantité, on diffère le
    // rafraîchissement (re-essai) pour ne pas écraser sa saisie en cours.
    if (Date.now() < (window.__cosCartEditingUntil || 0)) {
      return new Promise(function (resolve) {
        setTimeout(function () { refreshCartDrawer(originalFetch).then(resolve).catch(resolve); },
          ((window.__cosCartEditingUntil || 0) - Date.now()) + 200);
      });
    }
    // Capture epoch so we can skip this render if a newer one started
    var epoch = typeof window.__cartDrawerRenderEpoch !== 'undefined'
      ? ++window.__cartDrawerRenderEpoch : 0;

    var drawerPromise = originalFetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (sectionHtml) {
        if (!sectionHtml) return;
        // Skip if a newer render started while this fetch was in flight
        if (epoch && window.__cartDrawerRenderEpoch !== epoch) return;
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var currentItems = cartDrawer.querySelector('.cart-drawer-items');
        var currentFooter = cartDrawer.querySelector('.drawer__footer');
        if (currentItems) currentItems.classList.add('is-updating');
        if (currentFooter) currentFooter.classList.add('is-updating');

        var newItems = parsed.querySelector('.cart-drawer-items');
        if (newItems && currentItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }
        var newFooter = parsed.querySelector('.drawer__footer');
        if (newFooter && currentFooter) {
          currentFooter.outerHTML = newFooter.outerHTML;
        } else if (newFooter && !currentFooter) {
          var drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.insertAdjacentHTML('beforeend', newFooter.outerHTML);
        }

        var hasItems = newItems && newItems.querySelectorAll('.cart-item').length > 0;
        cartDrawer.classList.toggle('is-empty', !hasItems);
        var drawerItemsEl = cartDrawer.querySelector('cart-drawer-items');
        if (drawerItemsEl) drawerItemsEl.classList.toggle('is-empty', !hasItems);

        requestAnimationFrame(function () {
          var updatedItems = cartDrawer.querySelector('.cart-drawer-items');
          var updatedFooter = cartDrawer.querySelector('.drawer__footer');
          if (updatedItems) updatedItems.classList.remove('is-updating');
          if (updatedFooter) updatedFooter.classList.remove('is-updating');
        });

        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
        if (typeof CosCartModules !== 'undefined' && CosCartModules.init) {
          CosCartModules.init();
        }
      });

    var bubblePromise = originalFetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (bubbleHtml) {
        if (!bubbleHtml) return;
        var bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          var parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var newBubble = parsed.querySelector('.shopify-section');
          if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
        }
      });

    return Promise.all([drawerPromise, bubblePromise]);
  }

  // Check if the gift variant is present in a cart
  function cartHasGift(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return item.variant_id === giftVariantId && item.properties && item.properties[GIFT_PROPERTY];
    });
  }

  // Analyze cart data and return action needed
  function analyzeCart(cart) {
    var giftItem = null;
    var giftLineIndex = -1;
    var nonGiftQty = 0;

    cart.items.forEach(function (item, index) {
      if (item.variant_id === giftVariantId && item.properties && item.properties[GIFT_PROPERTY]) {
        giftItem = item;
        giftLineIndex = index + 1;
      } else {
        nonGiftQty += item.quantity;
      }
    });

    if (giftItem && nonGiftQty < threshold) return { action: 'remove', line: giftLineIndex };
    if (!giftItem && nonGiftQty >= threshold && !isGiftDismissed()) return { action: 'add' };
    return { action: 'none' };
  }

  // On cart CHANGE: read cart from response directly
  // delayRefresh: when true, gift is added/removed server-side and the drawer
  // refresh is DELAYED (800ms) so updateQuantity() finishes rendering first.
  // This prevents the "bounce-back" race condition while still updating the
  // drawer to reflect gift changes (add/remove).
  function enforceGiftFromCart(cart, originalFetch, delayRefresh) {
    if (isProcessing) return;
    var result = analyzeCart(cart);
    if (result.action === 'none') return;

    isProcessing = true;

    var actionPromise;
    if (result.action === 'remove') {
      actionPromise = originalFetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: result.line, quantity: 0 }),
        _complementaryAutoAdd: true,
      });
    } else {
      // Adding gift — clear the dismissed flag since system is adding
      clearGiftDismissed();
      actionPromise = originalFetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: giftVariantId, quantity: addQty, properties: giftProperties() }],
        }),
        _complementaryAutoAdd: true,
      });
    }

    actionPromise
      .then(function () {
        // Update tracking after system add/remove
        if (result.action === 'add') previousCartHadGift = true;
        if (result.action === 'remove') previousCartHadGift = false;
        if (delayRefresh) {
          // Delay refresh to let updateQuantity() finish rendering first,
          // then update the drawer to show gift added/removed.
          return new Promise(function (resolve) {
            setTimeout(function () {
              refreshCartDrawer(originalFetch).then(resolve).catch(resolve);
            }, 800);
          });
        }
        return refreshCartDrawer(originalFetch);
      })
      .catch(function (err) {
        console.error('[Complementary Auto-Add]', err);
      })
      .then(function () {
        isProcessing = false;
      });
  }

  var originalFetch = window.fetch;

  // Track the previous cart state to detect user-initiated gift removal
  var previousCartHadGift = false;

  // ─── Fiabilité cadeau (anti « cadeau manquant », surtout ajout multi/pack) ───
  // 1) Watchdog : libère un verrou isProcessing resté bloqué (> 5 s) qui
  //    empêcherait l'ajout du cadeau aux opérations suivantes.
  var __cosBusyStamp = 0;
  setInterval(function () {
    if (isProcessing) {
      if (!__cosBusyStamp) __cosBusyStamp = Date.now();
      else if (Date.now() - __cosBusyStamp > 5000) { isProcessing = false; __cosBusyStamp = 0; }
    } else { __cosBusyStamp = 0; }
  }, 1000);
  // 2) Réconciliation à l'ouverture du tiroir : si le cadeau manque alors que le
  //    seuil est atteint, on l'ajoute (couvre les ajouts de pack / multi-articles
  //    où l'ajout du cadeau a été sauté). enforceGiftFromCart reste protégé par
  //    isProcessing → pas de doublon si une opération est réellement en cours.
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var lastRun = 0;
    new MutationObserver(function () {
      if (!drawer.classList.contains('active')) return;
      if (Date.now() < (window.__cosCartEditingUntil || 0)) return;
      if (Date.now() - lastRun < 800) return;
      lastRun = Date.now();
      originalFetch(routes.cart_url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) enforceGiftFromCart(cart, originalFetch, false); })
        .catch(function () {});
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  window.fetch = function () {
    var url = arguments[0];
    var opts = arguments[1] || {};

    var isCartAdd =
      typeof url === 'string' &&
      url.indexOf('/cart/add') !== -1 &&
      opts.method &&
      opts.method.toUpperCase() === 'POST';

    var isCartChange =
      typeof url === 'string' &&
      url.indexOf('/cart/change') !== -1 &&
      opts.method &&
      opts.method.toUpperCase() === 'POST';

    if (opts._complementaryAutoAdd) {
      return originalFetch.apply(this, arguments);
    }

    if (isCartAdd) {
      // When user adds a new product, clear the dismissed flag — fresh intent
      clearGiftDismissed();

      var formEl = document.querySelector('product-form form');
      var qtyInput = formEl ? formEl.querySelector('[name="quantity"]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (qty >= threshold && !isProcessing) {
        isProcessing = true;

        var mainPromise = originalFetch.apply(this, arguments);

        // On ajoute le cadeau UNIQUEMENT après le succès de l'ajout du produit
        // (séquentiel) → évite le panier « cadeau seul » en cas d'échec ou de
        // course de l'ajout produit. On ne lit que res.ok (pas le corps).
        mainPromise.then(function (res) {
          if (!res || !res.ok) { isProcessing = false; return; }
          // Anti-doublon : si le cadeau est déjà présent, NE PAS le ré-ajouter
          // (sinon sa quantité s'accumule à chaque produit ajouté → compteur faux).
          originalFetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (curCart) {
            if (cartHasGift(curCart)) {
              setTimeout(function () {
                refreshCartDrawer(originalFetch).then(function () { isProcessing = false; });
              }, 50);
              return;
            }
            originalFetch(routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: giftVariantId, quantity: addQty, properties: giftProperties() }],
              }),
              _complementaryAutoAdd: true,
            }).then(function () {
              previousCartHadGift = true;
            }).catch(function (err) {
              console.error('[Complementary Auto-Add]', err);
            }).then(function () {
              setTimeout(function () {
                refreshCartDrawer(originalFetch).then(function () { isProcessing = false; });
              }, 50);
            });
          }).catch(function () { isProcessing = false; });
        }).catch(function () { isProcessing = false; });

        return mainPromise;
      }

      return originalFetch.apply(this, arguments);
    }

    if (isCartChange) {
      return originalFetch.apply(this, arguments).then(function (response) {
        var cloned = response.clone();
        cloned.json().then(function (cart) {
          if (cart && cart.items) {
            // Detect user-initiated gift removal:
            // Gift was in cart before, no longer in cart now, and this is NOT from the auto-add system
            var giftStillInCart = cartHasGift(cart);
            if (previousCartHadGift && !giftStillInCart) {
              // User manually removed the gift — remember this
              setGiftDismissed();
            }
            // Update tracking for next change
            previousCartHadGift = giftStillInCart;

            // If cart is empty, clear dismissed flag (fresh start)
            if (cart.item_count === 0) {
              clearGiftDismissed();
            }

            // Réconciliation cadeau différée (anti bounce-back) : on attend que
            // l'utilisateur ait fini d'éditer avant d'ajouter/retirer le cadeau et
            // de rafraîchir le tiroir (sinon décalage d'index + saut de quantité).
            scheduleGiftReconcile(originalFetch);
          }
        }).catch(function () {});
        return response;
      });
    }

    return originalFetch.apply(this, arguments);
  };

  // Initialize tracking: check current cart state on page load
  originalFetch(routes.cart_url + '.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.items) {
        previousCartHadGift = cartHasGift(cart);
      }
    })
    .catch(function () {});
})();
